import axios from "axios";
import Vue from "vue";

const ENDPOINT = `${Vue.prototype.API_ENDPOINT}/graphql`;

export default {
  namespaced: true,

  state: {},

  mutations: {},

  getters: {},

  actions: {
    query({ commit, rootState }, _query) {
      let query = _query;
      if (query.length == 0) return;

      if (
        query.indexOf("domains()") !== -1 ||
        query.indexOf("domainsItau()") !== -1
      ) {
        query = query.replace("domains()", "domains ");
        query = query.replace("domainsItau()", "domainsItau ");
      }

      const params = new URLSearchParams();
      params.append(
        "query",
        `
      query {
        ${query}
      }
      `
      );

      // eslint-disable-next-line consistent-return
      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              if (resp.data.error) {
                reject(resp.data.error);
                return;
              }

              const response = resp.data.data;

              /**
               * Para não ter que criar um novo módulo para o formStruct,
               * então apenas alteramos o retorno da request para que o formStruct
               *  esteja dentro do user, assim poderemos manupular formStruct dentro do módulo user.
               */
              if (response.formStruct && response.user) {
                response.user.formStruct = response.formStruct;
              }

              const modulesNames = Object.keys(response);

              modulesNames.forEach((_moduleName) => {
                let moduleName = _moduleName;
                const listOfData = response[moduleName];
                const keys = Object.keys(listOfData || {});

                keys.forEach((key) => {
                  if (modulesNames[0] == "user") {
                    if (listOfData.profile) {
                      listOfData.profile[key] = listOfData[key];
                    }
                  }

                  if (key == "profile" && moduleName != 'profileQuestionUpdate') {
                    listOfData[key].id = rootState.user.profile.id;
                  }

                  if (moduleName == "domainsItau") {
                    moduleName = "domains";
                  }

                  const setter = `SET_${key.toUpperCase()}`;
                  // eslint-disable-next-line no-underscore-dangle
                  if (
                    Object.keys(this._mutations).indexOf(
                      `${moduleName}/${setter}`
                    ) !== -1
                  ) {
                    commit(`${moduleName}/${setter}`, listOfData[key], {
                      root: true,
                    });
                  }
                });
              });

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },
  },
};
